import authInstance from "../Interceptor/interceptor";

export const addDepartmentEffect = (formData) => {
    return authInstance.post("/departments/insert", formData);
};

export const deleteDepartmentEffect = (id) => {
    return authInstance.delete(`/departments/delete/${id}`);
};

export const editDepartmentEffect = (data) => {
    const { department_name, status, id } = data;
    const formData = { department_name, status };
    return authInstance.put(`/departments/update/${id}`, formData);
};


export const viewDepartmentEffect = (id) => {
    return authInstance.get(`/Department/${id}`);
};

export const listDepartmentEffect = () => {
    return authInstance.get("/departments/getlist");
};

export const listCommonDepartmentEffect = () => {
    return authInstance.get("/common/departments");
};
